module.exports = __webpack_public_path__ + "static/media/6.306a59ca.svg";